export const ADMIN_CHART = {
  primary: '#6C4EFF',
  secondary: '#8A72FF',
  tertiary: '#B1A0FF',
  lightFill: '#E6E1FF',
  extra: '#4F7CFF',
  neutral: '#8B7BA3',
  positive: '#34D399',
  negative: '#DC2626',
} as const;

export const ADMIN_AXIS_LABEL = ADMIN_CHART.neutral;

export const ADMIN_LEGEND_LABEL = '#6B778C';

export const ADMIN_PALETTE = {
  primary: ADMIN_CHART.primary,
  accent: ADMIN_CHART.secondary,
  mid: ADMIN_CHART.tertiary,
  soft: ADMIN_CHART.lightFill,
  muted: ADMIN_CHART.neutral,
  warm: ADMIN_CHART.extra,
  border: '#E5E9EB',
} as const;

export const ADMIN_STATUS_COLORS: Record<string, string> = {
  live: ADMIN_CHART.positive,
  scheduled: ADMIN_CHART.secondary,
  completed: ADMIN_CHART.neutral,
  paused: ADMIN_CHART.extra,
  draft: ADMIN_CHART.tertiary,
};

export const ADMIN_FUNNEL_COLORS = {
  total: ADMIN_CHART.primary,
  approved: ADMIN_CHART.positive,
  pending: ADMIN_CHART.secondary,
  aiFlagged: ADMIN_CHART.tertiary,
  rejected: ADMIN_CHART.negative,
} as const;

export const ADMIN_CAMPAIGN_STATUS_PILL: Record<string, string> = {
  live: 'bg-[#D1FAE5] text-[#047857]',
  scheduled: 'bg-[#E6E1FF] text-[#8A72FF]',
  completed: 'bg-[#F5F5F5] text-[#8B7BA3]',
  paused: 'bg-[#EFF6FF] text-[#4F7CFF]',
  draft: 'bg-[#F5F5F5] text-[#9B919D]',
};

export const ADMIN_CREATOR_STATUS_PILL: Record<string, string> = {
  accepted: 'bg-[#D1FAE5] text-[#047857]',
  rejected: 'bg-[#FEE2E2] text-[#DC2626]',
  blocked: 'bg-[#F5F5F5] text-[#8B7BA3]',
  pending: 'bg-[#E6E1FF] text-[#6C4EFF]',
};

export const ADMIN_NEWSLETTER_STATUS_PILL: Record<string, string> = {
  active: 'bg-[#D1FAE5] text-[#047857]',
  inactive: 'bg-[#F5F5F5] text-[#8B7BA3]',
  pending: 'bg-[#E6E1FF] text-[#6C4EFF]',
  unsubscribed: 'bg-[#FEE2E2] text-[#DC2626]',
};

export const ADMIN_POSITIVE_CHIP = 'bg-[#D1FAE5] text-[#047857]';

export const ADMIN_POSITIVE_MUTED_BG = 'bg-[#D1FAE5]';

export const ADMIN_NEGATIVE_CHIP = 'bg-[#FEE2E2] text-[#DC2626]';

export const ADMIN_NEUTRAL_CHIP = 'bg-[#F5F5F5] text-[#8B7BA3]';

export const ADMIN_AVATAR_FALLBACK_BG = 'bg-[#E6E1FF]';

export const ADMIN_AVATAR_FALLBACK_TEXT = 'text-[#6C4EFF]';

export const ADMIN_METRIC_ACCENT_TEXT = 'text-[#6C4EFF]';

export const ADMIN_TEXT_MUTED_HOVER_ACCENT =
  'text-[#9B919D] hover:text-[#6C4EFF]';

export const ADMIN_SOFT_BADGE =
  'inline-block text-xs font-semibold px-2.5 py-1 rounded-full bg-[#E6E1FF] text-[#8A72FF]';

export const ADMIN_PROGRESS_BAR_PRIMARY_CLASS = 'bg-[#6C4EFF]';

export const ADMIN_PROGRESS_BAR_SECONDARY_CLASS = 'bg-[#34D399]';

export const ADMIN_EMPTY_STATE_ICON_BG = 'bg-[#E6E1FF]';
